import { gql } from "@apollo/client";

const AGENT_TASK_FIELDS = gql`
  fragment AgentTaskFields on AgentTask {
    id
    state
    agentStatus
    createdAt
    progress {
      stepsCompleted
      stepsTotal
    }
  }
`;

export { AGENT_TASK_FIELDS };
